import "./edit-employee-incentive.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormEmployeeIncentive from "../form-employee-incentive/form-employee-incentive";
import { useEditEmployeeIncentive } from "./edit-employee-incentive.hook";

export function EditEmployeeIncentive() {
  const {
    employeeIncentiveData,
    isLoading,
    employeeIncentiveError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditEmployeeIncentive();

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
        <FormEmployeeIncentive />
      </section>
    </div>
  );

  return (
    <div id="EmployeeIncentive" className="employee-incentive">
      <HeaderContent
        title={"Edit Employee Incentive"}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {employeeIncentiveError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditEmployeeIncentive;
